// src/constants/action-icons.js

export const SEQUENCE_ELEMENT_ICONS = {
    action_show: 'visibility',
    action_hide: 'visibility_off',
    action_toggle_show_hide: 'toggle_on',
    action_play: 'play_arrow',
    action_pause: 'pause',
    action_toggle_play_pause: 'toggle_on',
    action_stop: 'stop',
    action_seek: 'fast_forward',
    action_end: 'keyboard_tab',
    action_animate: 'animation',
    action_spin: '360',
    action_orbit: 'rotate_right',
    action_transform_to: 'move_up',
    action_transform_by: 'photo_size_select_small',
    action_move_in_direction: 'directions_run',
    action_set_materials_variant: 'palette',
    action_play_particles: 'snowing',
    action_change_space: 'double_arrow',
    action_open_url: 'link',
    action_show_instructions: 'notes',
    action_open_home: 'map',
    action_raise_event: 'launch',
    action_set_experience_origin: 'ads_click',
    action_force_end_sequence: 'cancel',
    action_start_following: 'phonelink_lock',
    action_stop_following: 'phonelink_erase',
    action_send_amqp_message: 'send',
    action_send_mqtt_message: 'send',
    action_history_back: 'arrow_back',
    trigger_image_anchor_found: 'image_search',
    trigger_tap: 'touch_app',
    trigger_screen_tap: 'touch_app',
};